// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.submission-poup-content {
  padding: 20px 24px;
}
.submission-poup-content .submission-card {
  background: #f6f8ff;
  border-radius: 16px;
  padding: 24px;
}
.submission-poup-content .submission-card .submission-details label {
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #4b5563;
  opacity: 0.5;
}
.submission-poup-content .submission-card .submission-details span {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
}
.submission-poup-content .submission-card .gc-submission-user {
  display: flex;
  align-items: center;
  gap: 13px;
}
.submission-poup-content .submission-card .gc-submission-user .SU-avatar {
  width: 68px;
  height: 68px;
  background: #e7ecf0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #000000;
}
.submission-poup-content .submission-card .gc-submission-user .SU-info p {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #1f2937;
}
.submission-poup-content .submission-card .gc-submission-user .SU-info span {
  font-style: italic;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #4b5563;
  opacity: 0.5;
}
.submission-poup-content button.accept-btn {
  padding: 10px 12px;
  border: none;
  width: 119px;
  height: 40px;
  background: rgba(16, 185, 129, 0.1);
  border-radius: 6px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #6ACE6A;
  cursor: pointer;
}
.submission-poup-content button.recheck-btn {
  width: 119px;
  height: 40px;
  background: rgba(198, 106, 158, 0.1);
  border-radius: 6px;
  border: none;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #C66A9E;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #ecf0f5;
  gap: 24px;
}

.esco-updload-btn {
  position: fixed;
  top: 8px;
  right: 60px;
}

.t-b {
  color: black !important;
}

/**/
.accpt-text {
  color: #0A6ED9;
  border: 1px solid #0A6ED9;
  border-radius: 8px;
  padding: 6px 8px;
}

.recheck-text {
  color: #C66A9E;
  border: 1px solid #C66A9E;
  border-radius: 8px;
  padding: 6px 8px;
}

th.AC-f,
th#checkboxVisitDetails {
  width: 55px;
}

th.AC-status {
  width: 250px !important;
}

.cw-heading p {
  color: #1f2937;
  padding-top: 3px;
}

.accepted-ques {
  color: #6ACE6A;
}

.rejected-ques {
  color: #C66A9E;
}

.w-390 {
  width: 390px;
}

.collapsible-header {
  display: flex;
  align-items: center;
  gap: 8px;
  -webkit-user-select: none;
          user-select: none;
}
.collapsible-header i {
  font-size: 14px;
  transition: transform 0.2s ease;
}
.collapsible-header:hover {
  opacity: 0.8;
}

.qa-notes-cell {
  position: relative;
  min-width: 200px;
}
.qa-notes-cell .qa-notes-display {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.qa-notes-cell .qa-notes-display:hover {
  background-color: #f3f4f6;
}
.qa-notes-cell .qa-notes-display:hover .qa-notes-edit-icon {
  opacity: 1;
}
.qa-notes-cell .qa-notes-display .image-text {
  flex: 1;
  word-break: break-word;
}
.qa-notes-cell .qa-notes-display .image-text.empty-text {
  color: #9ca3af;
  font-style: italic;
}
.qa-notes-cell .qa-notes-display .qa-notes-edit-icon {
  opacity: 0;
  transition: opacity 0.2s ease;
  color: #0A6ED9;
  font-size: 14px;
  cursor: pointer;
  padding: 4px;
}
.qa-notes-cell .qa-notes-display .qa-notes-edit-icon:hover {
  color: #0855a8;
}
.qa-notes-cell .qa-notes-edit {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.qa-notes-cell .qa-notes-edit .qa-notes-textarea {
  width: 100%;
  min-width: 250px;
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s ease;
}
.qa-notes-cell .qa-notes-edit .qa-notes-textarea:focus {
  outline: none;
  border-color: #0A6ED9;
  box-shadow: 0 0 0 3px rgba(10, 110, 217, 0.1);
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions .qa-notes-save-btn {
  height: 32px;
  width: 84px;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions .qa-notes-save-btn i.pi-spinner {
  display: inline-block;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions .qa-notes-cancel-btn {
  height: 32px;
  border: 1px solid #1E38A9;
  width: 84px;
}
.qa-notes-cell .qa-notes-edit .qa-notes-actions .qa-notes-cancel-btn:hover:not(:disabled) {
  border: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
